import React from 'react';

import { faAngleRight } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DropdownMenuTrigger as ShadcnDropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { SidebarMenuButton } from '@/components/ui/sidebar';
import { AvatarWithEmail } from '../../../../../../../../../shared/components/Avatar';
import { SIDEBAR_MENU_BUTTON_CLASSES } from '../../../../constants';
import { userShape } from '../../../../types';

const DropdownMenuTrigger = ({ user }) => {
  const { avatarColor, email, fullName, initials } = user;

  const avatarProps = {
    avatarColor,
    email,
    fullName,
    initials,
  };

  return (
    <ShadcnDropdownMenuTrigger asChild>
      <SidebarMenuButton className={SIDEBAR_MENU_BUTTON_CLASSES} size="lg">
        <AvatarWithEmail {...avatarProps} />
        <FontAwesomeIcon className="ml-auto" icon={faAngleRight} />
      </SidebarMenuButton>
    </ShadcnDropdownMenuTrigger>
  );
};

DropdownMenuTrigger.propTypes = {
  user: userShape.isRequired,
};

export default DropdownMenuTrigger;
